import { render, staticRenderFns } from "./TesseractGreenIcon.vue?vue&type=template&id=6dde59aa&"
import script from "./TesseractGreenIcon.vue?vue&type=script&lang=ts&"
export * from "./TesseractGreenIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports